<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <bar-card class="lefts" :bg="'border2'">
          <v-title>气象站</v-title>
          <div class="panelContent">
            <right-top />
          </div>
        </bar-card>
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>土壤墒情</v-title>
          <div class="panelContent">
            <right-mid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts3" :bg="'border2'">
          <v-title>农情监测</v-title>
          <div class="panelContent">
            <right-nqmid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts3" :bg="'border2'">
          <v-title>视频监控</v-title>
          <div class="panelContent">
            <right-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import rightTop from "./rightBar/rightTop";
import rightMid from "./rightBar/rightMid";
import rightBot from "./rightBar/rightBot";
import rightNqmid from "./rightBar/rightNqmid";
export default {
  components: { rightTop, rightBot, rightMid, rightNqmid },
  data() {
    return {};
  },
};
</script>

<style lang="stylus" scoped>
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  height 25%
  margin-bottom 10px
.lefts2
    height calc(25% - 10px)
    margin-bottom 10px
.lefts3
  height calc(25% - 10px)
  margin-bottom 10px
.lefts4
    height calc(25% - 10px)
    margin-bottom 10px
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
